import React from 'react'
import ReactDOM from 'react-dom'
import Demo from '../components/demo'
import EmbedQuote from '../components/embed-quote'

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <EmbedQuote />,
    document.getElementById("jyst-booking-form")
  )
})